/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const MonospaceIcon = /*#__PURE__*/ createSvgIcon(
  'MonospaceIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <path
            d="M4.001 4.628h1v6.745H3.996v1h3.006v-1h-1v-4.94l1.402 3.083h1.209l1.391-3.027v4.884H9v1h3.011v-1h-1.008V4.628h.995v-1h-1.776L8.004 8.453 5.809 3.628H4v1z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 15V1h14v14H1zM2 2h12v12H2V2z"
            fill="currentColor"
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            d="M3.997 5h1.518v9.755H4.002v1H8.01v-1H6.515V5.778l2.873 6.226h1.248l2.865-6.21v8.961h-1.505v1h4.015v-1H14.5V5H16V4h-2.772l-3.216 6.97L6.796 4h-2.8v1z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 19V1h18v18H1zM2 2h16v16H2V2z"
            fill="currentColor"
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            d="M15.797 4.504l-3.793 8.293L8.18 4.504H4.75v1h2.036v12.741H4.768v1h4.996v-1H7.786V6.153l3.609 7.844 1.24.003 3.579-7.782v12.027h-1.958v1h4.994v-1h-2.036V5.504h2.036v-1h-3.453z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 23V1h22v22H1zM2 2h20v20H2V2z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default MonospaceIcon;
